import * as React from "react";
import { Input } from "reactstrap";
import { DropDownBase, GenericSelectItem, IDropDownProps } from "../utils/base/DropDownBase";
import { ColegioService } from "./ColegioService";


export class ColegiosDropDown extends DropDownBase<IDropDownProps> {

    

    protected GetItems(): Promise<GenericSelectItem[]> {
        var service = new ColegioService();
        var itemsProm = service.getAll()
            .then((items) => {
                return items.map(center => {
                    return {
                        id: center.id,
                        name: center.nombre,
                    } as GenericSelectItem;
                });
            
        });

        return itemsProm;
    }

    protected shouldAddEmptyOption() {
        return true;
    }
};